import React from 'react';
import { usePostForm } from '../../config/PostFormContext';
import PostFormModal from '../PostFormModal/PostFormModal';
import logger from '../../utils/logger';

const ModalManager = () => {
  const {
    isEditModalOpen,
    isPostModalOpen,
    postToEdit,
    closeEditModal,
    closePostModal,
  } = usePostForm();

  // Log modal state changes for debugging
  React.useEffect(() => {
    if (isEditModalOpen) {
      logger.debug('ModalManager: Edit modal opened for post:', postToEdit?.id);
    }
    if (isPostModalOpen) {
      logger.debug('ModalManager: Post modal opened');
    }
  }, [isEditModalOpen, isPostModalOpen, postToEdit?.id]);

  return (
    <>
      {/* Edit Modal */}
      {isEditModalOpen && (
        <PostFormModal
          show={isEditModalOpen}
          onClose={closeEditModal}
          isEditing={true}
          postToEdit={postToEdit}
        />
      )}

      {/* Post Modal */}
      {isPostModalOpen && (
        <PostFormModal
          show={isPostModalOpen}
          onClose={closePostModal}
          isEditing={false}
          postToEdit={null}
        />
      )}
    </>
  );
};

export default ModalManager;
